<template>
    <div>
        
            <div class="container">
                <div class="row">
                    <div class="col-md-3">
                         <label for="cost">مبلغ خرید:</label>
                        <div class="input-group mb-3">
                           
                                    <input type="number" class="input" placeholder="6000000" aria-label="cost" >
                               
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="">ریال</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                         <label for="cost">تعداد اقساط:</label>
                         <div class="input-group mb-3">
                                <select class="custom-select" id="exampleFormControlSelect1">
                                    <option>12</option>
                                    <option>24</option>
                                </select>
                                 <div class="input-group-prepend">
                                    <span class="input-group-text" id="">ماه</span>
                                </div>
                    </div>
                    </div>
            </div>
    </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>